module.exports = __webpack_public_path__ + "static/media/tatiany.1aa81769.bin";